"use client";
import throttle from "lodash.throttle";
import { DependencyList, useEffect, useMemo } from "react";

export interface Configs {
	ttl?: number;
}
export default function useScrollYChange(callback: (scrollYPosition: number) => void, deps?: DependencyList, configs?: Configs): void {
	const onScrollEvent = useMemo(
		() =>
			throttle(() => {
				const { scrollY: clientScrollY } = window;
				callback(clientScrollY);
			}, configs?.ttl ?? 300),
		[callback, configs?.ttl]
	);

	useEffect(() => {
		window.addEventListener("scroll", onScrollEvent);
		return () => {
			window.removeEventListener("scroll", onScrollEvent);
			onScrollEvent.cancel();
		};
	}, [onScrollEvent, ...(deps ?? [])]);
}
